import {
    Avatar,
    Box,
    IconUser,
    Image,
    MediaObject,
    Paragraph,
} from '@zillow/constellation';
import { withPreload, PostReadTime } from '@zillow/zrs-cms';
import React from 'react';

import { PostByLineProps } from './PostByLine.types';

const ImagePreload = withPreload(Image);

const PostByLine: React.FC<PostByLineProps> = ({ author, readTime, date }) => {
    const publishDateObject = date ? new Date(date) : null;
    const AvatarImage = author?.avatar ? (
        <ImagePreload src={author.avatar} />
    ) : (
        <IconUser />
    );

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '$spacing.md',
            }}
        >
            <MediaObject
                media={<Avatar size="md">{AvatarImage}</Avatar>}
                align="center"
            >
                {!!author?.name && (
                    <Paragraph fontType="bodySmall">{author.name}</Paragraph>
                )}
                {publishDateObject && (
                    <Paragraph fontType="bodySmall">
                        {publishDateObject.toLocaleDateString('en-US', {
                            month: 'long',
                            day: 'numeric',
                            year: 'numeric',
                        })}
                    </Paragraph>
                )}
            </MediaObject>
            <PostReadTime readTime={readTime} />
        </Box>
    );
};

export default PostByLine;
